import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_REFERRAL_MEMBER_REQUEST,
  GET_REFERRAL_MEMBER_SUCCESS,
  GET_REFERRAL_MEMBER_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getReferralMemberSaga(action) {
  try {
    const result = yield call(api.getReferralMember, action.payload)
    yield put({ type: GET_REFERRAL_MEMBER_SUCCESS, payload: result.data })
  } catch (error) {
    yield put({ type: GET_REFERRAL_MEMBER_FAILURE, error })
  }
}

export function* getReferralMemberWatcherSaga() {
  yield takeLatest(GET_REFERRAL_MEMBER_REQUEST, getReferralMemberSaga)
}
